import type { Bar, Timeframe } from '../types';

export function aggregateConfirmedMinutes(bars: Bar[], timeframe: Timeframe): Bar[] {
  if (timeframe === '1m') return bars;
  const size = timeframe === '5m' ? 5 : timeframe === '15m' ? 15 : 60;
  return aggregateMinuteBars(bars, size);
}

export function aggregateMinuteBars(bars: Bar[], size: number): Bar[] {
  const seconds = size * 60;
  const out: Bar[] = [];
  let bucket: Bar[] = [];
  let end = -1;
  const flush = () => {
    if (bucket.length === size && bucket[0].time === end - (size - 1) * 60 &&
      bucket.every((bar, i) => i === 0 || bar.time - bucket[i - 1].time === 60))
      out.push({ time: end, open: bucket[0].open, high: Math.max(...bucket.map(b => b.high)),
        low: Math.min(...bucket.map(b => b.low)), close: bucket.at(-1)!.close,
        volume: bucket.reduce((sum, bar) => sum + bar.volume, 0) });
  };
  for (const bar of bars) {
    const nextEnd = Math.floor((bar.time - 1) / seconds) * seconds + seconds;
    if (nextEnd !== end) { if (bucket.length) flush(); bucket = []; end = nextEnd; }
    bucket.push(bar);
  }
  if (bucket.length) flush();
  return out;
}

export async function fetchHistory(token: string): Promise<{ contract: string | null; bars: Bar[] }> {
  const response = await fetch('/api/history?days=8', { headers: { Authorization: `Bearer ${token}` }, cache: 'no-store' });
  if (!response.ok) throw new Error(`History request failed: HTTP ${response.status}`);
  const raw = await response.json() as { contract: string | null; bars: Array<{ bar_time: string; open: number; high: number; low: number; close: number; volume: number }> };
  return { contract: raw.contract, bars: raw.bars.map(b => ({ time: Date.parse(b.bar_time) / 1000, open: b.open, high: b.high, low: b.low, close: b.close, volume: b.volume })) };
}
